module.exports = __webpack_public_path__ + "static/service03-e3dbe104fdc05444ebcda5c9e65a561f.png";